<template>
  <div class="w3-container w3-responsive">

    <!-- 内容区域 -->
    <div class="w3-card" style="max-width: 100%; margin: 0">
      <header class="w3-container w3-green">
        <h2>DashB</h2>
      </header>
      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>

      <div class="w3-container w3-padding-16 w3-text-grey">
        <div class="w3-flex" style="justify-content: space-between">
          <h6 @click="route('onlineuserlist');">Gaming Users:</h6>
          <h6>{{ $filters.formatNumber(gamingUsers) }}</h6>
          <h6 @click="route('userlist');">Total Users:</h6>
          <h6>{{ $filters.formatNumber(totalUsers) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>Today DAU:</h6>
          <h6>{{ $filters.formatNumber(todayDAU) }}</h6>
          <h6>LastDay DAU:</h6>
          <h6>{{ $filters.formatNumber(lastDayDAU) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>Today TopUp:</h6>
          <h6>{{ $filters.formatNumber(todayTopUp) }}</h6>
          <h6>LastDay TopUp:</h6>
          <h6>{{ $filters.formatNumber(lastDayTopUp) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>Today Profit:</h6>
          <h6>{{ $filters.formatNumber(todayProfit) }}</h6>
          <h6>LastDay Profit:</h6>
          <h6>{{ $filters.formatNumber(lastDayProfit) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>Today New User:</h6>
          <h6>{{ $filters.formatNumber(todayNewUsers) }}</h6>
          <h6>LastDay New User:</h6>
          <h6>{{ $filters.formatNumber(lastDayNewUsers) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>Tron Last Check Time:</h6>
          <h6>{{ $filters.formatDate(lstChkTime) }}</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      gamingUsers: 0,
      totalUsers: 0,
      todayDAU: 0,
      lastDayDAU: 0,
      todayTopUp: 0,
      lastDayTopUp: 0,
      todayProfit: 0,
      lastDayProfit: 0,
      todayNewUsers: 0,
      lastDayNewUsers: 0,
      lstChkTime: '',
      loading: false,
      error: ''
    };
  },
  mounted() {
    const query = this.$route.query;
    if (query.u && query.p) {
      sessionStorage.setItem('userName', query.u);
      sessionStorage.setItem('userPass', query.p);
    }
    this.userName = sessionStorage.getItem('userName');
    this.userPass = sessionStorage.getItem('userPass');
    if (this.userName && this.userPass) {
      this.fetchData();
      setInterval(() => {
        this.fetchData();
      }, 5000);
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {
        const response = await axios.get(`${this.$apiUrl}/getDashBData?username=${this.userName}&t=${this.userPass}`);
        if (response.data.code == 200) {
          this.gamingUsers = response.data.result.gamingUsers;
          this.totalUsers = response.data.result.totalUsers;
          this.todayDAU = response.data.result.todayDAU;
          this.lastDayDAU = response.data.result.lastDayDAU;
          this.todayTopUp = response.data.result.todayTopUp;
          this.lastDayTopUp = response.data.result.lastDayTopUp;
          this.todayProfit = response.data.result.todayProfit;
          this.lastDayProfit = response.data.result.lastDayProfit;
          this.todayNewUsers = response.data.result.todayNewUsers;
          this.lastDayNewUsers = response.data.result.lastDayNewUsers;
          this.lstChkTime = response.data.result.lstChkTime;
        } else if (response.data.code == 300) {
          this.error = response.data.result;
        } else if (response.data.code == 400) {
          this.$router.push('/login?err=1');
        } else if (response.data.code == 500) {
          this.error = response.data.result;
        }
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    route(url) {
      this.$router.push('/' + url);
    }
  }
};
</script>

<style scoped>
.w3-image {
  display: block;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border: 1px solid #ddd;
}
</style>